import { render, staticRenderFns } from "./view-coordinadores-imagenes.vue?vue&type=template&id=62788b8a"
import script from "./view-coordinadores-imagenes.vue?vue&type=script&lang=js"
export * from "./view-coordinadores-imagenes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports